import { TokenService } from './../token.service';
import { Http } from '@angular/http';
import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

import { MenuModulosComponent } from './../menu-modulos/menu-modulos.component';
import { MenuModulos } from './../menu-modulos/menu-modulos.model';

@Component({
  selector: 'cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss']
})
export class CabecalhoComponent implements OnInit {

  @Input('nomeModulo') nomeModulo: String;

  @Input('modulos') modulos: Array<MenuModulos> = [];

  @Output() toogleMenu = new EventEmitter();

  menuOnClick(evento) {
    this.toogleMenu.emit(evento);
  }

  constructor(private token:TokenService) { }

  ngOnInit() {
  }

  sair(evento) {
    this.token.revogarToken('/colaborador');
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/cabecalho/cabecalho.component.ts